// StayRottnest booking strategy.
//
// URL shape:
//   ${site.reserveUrl}&arrival=YYYY-MM-DD&departure=YYYY-MM-DD
//     &rooms=1&adults%5B1%5D=1&children%5B1%5D=0
//     [&roomCategories%5B%5D=<groupId> if site.extraAttributes.groupId set]

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    const checkout = resolveCheckout(ctx);
    const groupId = site.extraAttributes?.groupId;
    return `${site.reserveUrl}&arrival=${format(arrivalDate, "yyyy-MM-dd")}&departure=${format(checkout, "yyyy-MM-dd")}&rooms=1&adults%5B1%5D=1&children%5B1%5D=0${groupId ? `&roomCategories%5B%5D=${groupId}` : ""}`;
  },

  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs({ site } = {}) {
    const hasGroupId = Boolean(site?.extraAttributes?.groupId);
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as &arrival=YYYY-MM-DD.",
        },
        departureDate: {
          status: "required",
          notes: "Encoded as &departure=YYYY-MM-DD.",
        },
        ref: {
          status: "ignored",
          notes: hasGroupId
            ? "site.extraAttributes.groupId is appended as roomCategories[]; ref itself is not encoded."
            : "site.reserveUrl already identifies the property.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes:
            "Hard-coded adults[1]=1 & children[1]=0; partySize is not propagated per-request.",
        },
      },
    };
  },
};
